export default "__VITE_ASSET__B7K3dce6__"